import { formatNumber } from "../lib/format";

interface MoneyProps {
  amount: string | number;
  currency?: string;
  showSign?: boolean;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

const sizeClasses = {
  sm: "text-sm",
  md: "text-base",
  lg: "text-xl",
  xl: "text-3xl font-bold",
};

function formatAmount(amount: string | number): string {
  const n = typeof amount === "string" ? parseFloat(amount) : amount;
  if (isNaN(n)) return "—";
  return formatNumber(Math.abs(n));
}

export function Money({ amount, currency = "", showSign = false, className = "", size = "md" }: MoneyProps) {
  const n = typeof amount === "string" ? parseFloat(amount) : amount;
  const isValid = !isNaN(n);
  const isNeg = isValid && n < 0;
  const sign = showSign && isValid ? (isNeg ? "−" : "+") : "";
  const colorClass = showSign && isValid ? (isNeg ? "text-danger" : "text-success") : "";

  return (
    <span
      className={`font-mono [font-variant-numeric:tabular-nums] ${sizeClasses[size]} ${colorClass} ${className}`}
    >
      {sign}{currency}{formatAmount(amount)}
    </span>
  );
}
